export default "__VITE_ASSET__BxBZL5iP__"